import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMemo } from 'react';
import { useFlightDeckArtifact } from '@atlassiansox/flight-deck-frontend-client';
import { FD_CLIENT_FETCH_PROPS } from './constants';
var transformArtifactsWithOverrides = function transformArtifactsWithOverrides(artifact, overrideKeys) {
  var _artifact$overrides;
  if (!(artifact !== null && artifact !== void 0 && (_artifact$overrides = artifact.overrides) !== null && _artifact$overrides !== void 0 && _artifact$overrides.length) || overrideKeys.length === 0) {
    return artifact;
  }
  return overrideKeys.reduce(function (acc, overrideKey) {
    var _artifact$overrides$f;
    return _objectSpread(_objectSpread({}, acc), artifact.overrides && ((_artifact$overrides$f = artifact.overrides.find(function (override) {
      return override.key === overrideKey;
    })) === null || _artifact$overrides$f === void 0 ? void 0 : _artifact$overrides$f.item) || null);
  }, artifact);
};
export var usePeopleAndTeamsRemoteArtifact = function usePeopleAndTeamsRemoteArtifact(product, locale, overridesKeys) {
  var dimensions = useMemo(function () {
    return _objectSpread(_objectSpread({}, FD_CLIENT_FETCH_PROPS.dimensions), {}, {
      locale: locale
    });
  }, [locale]);
  var artifact = useFlightDeckArtifact(FD_CLIENT_FETCH_PROPS.name, dimensions);

  /**
   * FlightDeck doesn't allow custom, a 'product', dimension so we must handle this ourselves.
   * We can probably remove this memo once that functionality is available
   */
  return useMemo(function () {
    var productArtifact = artifact ? product in artifact['people-menu'] ? artifact['people-menu'][product] : artifact['people-menu'].default : null;
    return _defineProperty({}, 'people-menu', transformArtifactsWithOverrides(productArtifact, overridesKeys ? overridesKeys['people-menu'] : []));
  }, [artifact, product, overridesKeys]);
};